import React, { memo } from "react";
import { Box, Card, CardContent, Typography, useTheme, Divider, Grid, } from "@mui/material";
import { Booking } from "../../../models/booking";
import { paymentStatusColor } from "../common/bookingUtils";
import DiscountIcon from "@mui/icons-material/Discount";
import "../../../../styles/commonStyle.css"

interface EstimatedFareReadOnlyProps {
  booking: Booking;
}

const EstimatedFareReadOnly: React.FC<EstimatedFareReadOnlyProps> = ({ booking }) => {
  const theme = useTheme();


  return (
    <div className="card border rounded-3">
      <div className="card-body p-3">
        <h6 className="fw-bold text-uppercase mb-4" style={{ fontSize: "0.875rem" }}>
          Estimated Fare
        </h6>
        {[
          ["Base Fare", booking.payment.baseFare],
          [`Extra Kms (${booking.payment.extraKms})`, booking.payment.extraKmCharges],
          [`Waiting Time (${booking.payment.waitingTime})`, booking.payment.waitingCharges],
          ["Toll Charges", booking.payment.toll],
          ["GST (5%)", booking.payment.gstFare],
          ["Discount", booking.payment.discount ? booking.payment.discount : 0],
          ["Parking Fees", booking.payment.parking],
        ].map(([label, val]) => (
          <div key={label} className="d-flex justify-content-between mb-1" style={{ fontSize: "0.8rem" }}>
            <span>{label}</span>
            <span>₹{val}</span>
          </div>
        ))}
        <hr />
        <div className="d-flex justify-content-between fw-bold" style={{ fontSize: "0.875rem" }}>
          <span>Total Cost</span>
          <span>{booking.payment.totalFare}</span>
        </div>
      </div>
    </div>

  );
};

export default memo(EstimatedFareReadOnly);
